import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import './App.css'
import { Footer } from './components/footer'
import { Header } from './components/header'
import { Main } from './components/main'

export class App extends React.Component {
	render() {
		return (
			<Router>
				<div className='App'>
					<Header />
					<Main />
					<Footer />
					<ToastContainer position={toast.POSITION.BOTTOM_RIGHT} autoClose={5000} newestOnTop={true} />
				</div>
			</Router>
		)
	}
}



// WEBPACK FOOTER //
// ./src/App.tsx